import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Flag from 'components/Flag';
import COUNTRIES from 'assets/data/countries';
import { P } from 'components/Typography';
import { CountryDisplayWrapper } from './styled';

const StyledFlag = styled(Flag)`
  margin-right: 2px;
`;

const CountryDisplay = ({ countryCode, className, variant }) => {
  const country = COUNTRIES.find((c) => c.code === countryCode);

  return (
    <CountryDisplayWrapper className={className} variant={variant}>
      <StyledFlag code={country?.code} size={18} />
      <P>{country?.name || ''}</P>
    </CountryDisplayWrapper>
  );
};

CountryDisplay.defaultProps = {
  variant: 'light'
};

CountryDisplay.propTypes = {
  countryCode: PropTypes.string,
  variant: PropTypes.oneOf(['light', 'dark', 'azureWhite']),
  className: PropTypes.string
};

export default CountryDisplay;
